module.exports = __webpack_public_path__ + "static/media/borded_logo.24314d5e.svg";